exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-indicator {\n  float: left;\n  margin: 1em 2em;\n  cursor: default;\n  width: 180px; }\n  .circle-indicator .round-progress-bar-container {\n    position: relative;\n    margin-bottom: 1.7em; }\n    .circle-indicator .round-progress-bar-container .percentage {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      font-size: 1.5em;\n      -webkit-transform: translateY(-50%);\n      -moz-transform: translateY(-50%);\n      text-align: center;\n      color: #2CC185; }\n  .circle-indicator .title {\n    margin-top: 1em;\n    width: 100%;\n    text-align: center;\n    color: #1e966b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/views/dashboardView/CircleIndicatorComponent/circleIndicator.component.scss
// module id = ./src/app/modules/dashboard/views/dashboardView/CircleIndicatorComponent/circleIndicator.component.scss
// module chunks = main